import { useState, useEffect } from 'react';
import { LOCAL_STORAGE_KEYS } from '../constants';

export const useAuth = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem(LOCAL_STORAGE_KEYS.CURRENT_USER);
    if (storedUser) {
      const user = JSON.parse(storedUser);
      setCurrentUser(user);
      setIsAuthenticated(true);
    }
  }, []);

  const logout = () => {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.CURRENT_USER);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN);
    setCurrentUser(null);
    setIsAuthenticated(false);
    window.location.href = '/auth';
  };

  const login = (user, token) => {
    localStorage.setItem(LOCAL_STORAGE_KEYS.CURRENT_USER, JSON.stringify(user));
    if (token) {
      localStorage.setItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN, token);
    }
    setCurrentUser(user);
    setIsAuthenticated(true);
  };

  return {
    currentUser,
    isAuthenticated,
    login,
    logout,
  };
};
